import React, { SetStateAction, useState } from "react";
import Button from "../../component/Button";
import InputField from "../../component/Input";
import TextArea from "../../component/Input/textArea";
import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";

const ConnectPage: React.FC = () => {
  const [userEmail, setUserEmail] = useState("");
  const [body, setBody] = useState("");
  const [subject, setSubject] = useState(
    "Hi, Rajan we will like to talk to you about job offer"
  );
  const [isLoading, setisLoading] = useState(false);
  const [submitButtonTxt, setsubmitButtonTxt] = useState("Submit");
  const [isError, setisError] = useState(false);

  const inputFields = [
    {
      label: "Email",
      type: "email",
      value: userEmail,
      key: "login-Email-input",
      handleOnChange: (value: SetStateAction<undefined>) =>
        setUserEmail(value + ""),
    },
  ];

  const textArea = [
    {
      label: "Subject",
      type: "text",
      value: subject,
      key: "login-email-subject-input",
      handleOnChange: (value: SetStateAction<undefined>) =>
        setSubject(value + ""),
    },
    {
      label: "Message",
      type: "text",
      value: body,
      minHeight: "100px",
      key: "login-email-body-input",
      handleOnChange: (value: SetStateAction<undefined>) => setBody(value + ""),
    },
  ];

  const handleOnSubmit = () => {
    const templateParams = {
      from_name: userEmail,
      subject,
      message: body,
    };
    setisLoading(true);
    window.emailjs
      .send("service_oy97x8b", "template_9mzamht", templateParams)
      .then((res) => {
        setisLoading(false);
        setsubmitButtonTxt("Sent");
        console.log("res", res);
      })
      .catch((e) => {
        setsubmitButtonTxt("Retry");
        setisLoading(false);
      });
  };

  return (
    <section id="connect-section">
      <Jumbotron
        width="100%"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        margin="0px auto"
      >
        <Text text="CONNECT" fs="60px" fontWeight="bold" />

        <Jumbotron
          width="90%"
          justifyContent="left"
          alignItems="left"
          flexDirection="column"
          margin="0px auto"
        >
          {inputFields && inputFields.map((field) => <InputField {...field} />)}
          {textArea && textArea.map((field) => <TextArea {...field} />)}
        </Jumbotron>
        <Button
          bg="gray"
          margin="10px 10px 0 0"
          fontSize="20px"
          padding="10px 15px"
          text={submitButtonTxt}
          isLoading={isLoading}
          flexGrow="unset"
          handleOnClick={() => handleOnSubmit()}
        />
      </Jumbotron>
    </section>
  );
};

export default ConnectPage;
